module.exports = __webpack_public_path__ + "img/ylws.d107058e.png";